import { PrivateSettings } from '@wix/wix-vod-api-site-based/privateSettings';
import { keysToSnakeCase } from '@wix/wix-vod-shared/common';
import { parseSuccessResponse } from './parsers/success-response';
import { toError } from '../../parsers/to-error';
import { PrivateSettingsService } from './settings';
import { UploaderId } from '@wix/wix-vod-constants/api-types';
const uniqueId = () => Date.now().toString();
const dateToNumber = (ts) => ts === null || ts === void 0 ? void 0 : ts.valueOf();
export class PrivateSettingsServiceV2 extends PrivateSettingsService {
    constructor(httpClient, baseUrl) {
        super();
        this.httpClient = httpClient;
        this.get = () => this.privateSettingsService
            .getSettings()
            .then(parseSuccessResponse)
            .catch(toError);
        this.update = (settings) => {
            return this.privateSettingsService
                .update(keysToSnakeCase(Object.assign(Object.assign({}, settings), { createdTs: dateToNumber(settings.createdTs), updatedTs: dateToNumber(settings.updatedTs) })))
                .then(parseSuccessResponse)
                .catch(toError);
        };
        this.reset = () => this.privateSettingsService
            .reset()
            .then((response) => response.data)
            .catch(toError);
        this.privateSettingsService = new PrivateSettings(httpClient, baseUrl);
    }
    getEmbedLogoUploaderId(logo) {
        return logo.id
            ? `${UploaderId.EMBED_LOGO}${logo.id}`
            : UploaderId.EMBED_LOGO;
    }
    removeEmbedLogo(settings, uploaderId) {
        const isRemovingDefault = settings.embedDefaultLogoId
            ? `${UploaderId.EMBED_LOGO}${settings.embedDefaultLogoId}` === uploaderId
            : false;
        return this.privateSettingsService
            .update(keysToSnakeCase(Object.assign(Object.assign({}, settings), { createdTs: dateToNumber(settings.createdTs), updatedTs: dateToNumber(settings.updatedTs), embedLogos: settings.embedLogos.filter((logo) => `${UploaderId.EMBED_LOGO}${logo.id}` !== uploaderId), embedDefaultLogoId: isRemovingDefault
                ? null
                : settings.embedDefaultLogoId })))
            .then(parseSuccessResponse)
            .catch(toError);
    }
    updateLogosAfterUpload(uploadData, settings) {
        const logos = settings.embedLogos;
        const { fileUrl, uploaderId } = uploadData;
        const isNewLogo = uploaderId === UploaderId.EMBED_LOGO;
        const updatedLogos = isNewLogo
            ? [...logos, { id: uniqueId(), url: fileUrl }]
            : logos.map((logo) => `${UploaderId.EMBED_LOGO}${logo.id}` === uploaderId
                ? Object.assign(Object.assign({}, logo), { url: fileUrl }) : logo);
        return this.update(Object.assign(Object.assign({}, settings), { embedLogos: updatedLogos }));
    }
    makeEmbedLogoDefault(settings, uploaderId) {
        const logoId = uploaderId.replace(UploaderId.EMBED_LOGO, '');
        return this.update(Object.assign(Object.assign({}, settings), { embedDefaultLogoId: logoId }));
    }
    removeEmbedLogoDefault(settings, uploaderId) {
        return this.update(Object.assign(Object.assign({}, settings), { embedDefaultLogoId: null }));
    }
}
//# sourceMappingURL=settings.v2.js.map